import React, { Fragment, memo } from 'react';
import T from 'prop-types';
import { Box } from '@material-ui/core';
import { ROW_TYPES, VIEWS } from 'workflow/constants/newInbox';
import DetailRows from '../DetailRows/DetailRows';
import DocumentDetail from '../DocumentDetail/DocumentDetail';
import WorkflowDocumentViewer from 'workflow/containers/WorkflowDocumentViewer';
import styles from './SDFARequest.scss';
import DetailRowsv4 from '../DetailRows/DetailRowsv4';

const rowConfigs = [
    {
        label: 'Sent From',
        field: 'sentFrom',
    },
    {
        label: 'Sent By',
        field: 'sentBy',
    },
    {
        label: 'Sent Date',
        field: 'sentDate',
        type: ROW_TYPES.DATETIME,
    },
    {
        label: 'Type',
        field: 'type',
    },
    {
        label: 'Due Date',
        field: 'dueDate',
        type: ROW_TYPES.DATE_NO_TZ,
    },
    {
        label: 'Reminder Date',
        field: 'reminderDate',
        type: ROW_TYPES.DATE_NO_TZ,
    },
    {
        label: 'Statement of Testament',
        field: 'signingStatement.statement',
    },
    {
        label: 'Description',
        field: 'description',
        type: ROW_TYPES.RICH_TEXT,
    },
];

const rowConfigsV4 = [
    {
        label: 'Binder',
        field: 'sentFrom',
        type: ROW_TYPES.LINK,
    },
    {
        label: 'Sent By',
        field: 'sentBy',
    },
    {
        label: 'Sent Date',
        field: 'sentDate',
        type: ROW_TYPES.DATETIME,
    },
    {
        label: 'Type',
        field: 'type',
    },
    {
        label: 'Due Date',
        field: 'dueDate',
        type: ROW_TYPES.DATE_NO_TZ,
    },
    {
        label: 'Description',
        field: 'description',
        type: ROW_TYPES.RICH_TEXT,
    },
];

export const SDFARequest = ({
    changeView,
    detail = {},
    institutionTimezone,
    isNewV4,
    isWorkflow = false,
    onCancelTask = () => { },
    isMobileView
}) => {
    return (
        <Fragment data-cy="SDFARequest">
            {isNewV4 ? (
                <DetailRowsv4
                    data={detail}
                    configs={rowConfigsV4}
                    timezone={institutionTimezone}
                    isMobileView={isMobileView}
                />
            ) : (
                <DetailRows
                    data={detail}
                    configs={rowConfigs}
                    timezone={institutionTimezone}
                />
            )}
            {!isNewV4 && (
                <DocumentDetail
                    changeView={changeView}
                    documentDetail={detail ? detail.document : {}}
                />
            )}
            {isNewV4 ? (
                <div
                    className={styles.taskTitleForWindow}
                    onClick={() => changeView(VIEWS.DOCUMENT_DETAIL)}
                >
                    <Box className={styles.documentTitle}>
                        {detail.document.name}
                    </Box>
                </div>
            ) : (
                <div className={styles.SDFARequest__Label}>Document Preview</div>
            )}
            <div className={styles.SDFARequest__DocumentPreview}>
                <WorkflowDocumentViewer
                    noScroll={true}
                    noHeader={true}
                    taskId={!isWorkflow && detail.id}
                    workflowId={isWorkflow && detail.id}
                    shouldGoBack={false}
                />
            </div>
            {isNewV4 && (
                <Fragment>
                    <Box className={styles.statementContainer}>
                        <div>Statement of Testament</div>
                        <div className={styles.statementValue}>{detail.statement}</div>
                    </Box>
                    {detail.recipients && detail.recipients.length > 1 && (
                        <Box className={styles.statementContainer}>
                            <div>User Assignments</div>
                            <Box display="flex" flexDirection="column">
                                <Box
                                    display="flex"
                                    flexDirection="row"
                                    className={styles.taskdetailV4}
                                    style={{ borderBottom: '2px solid #E4E4E4' }}
                                >
                                    <Box style={{ width: '70%' }} display="flex">
                                        <Box className={styles.taskLabel} style={{ width: '50%' }}>
                                            Name
                                        </Box>
                                        <Box className={styles.taskLabel} style={{ width: '50%' }}>
                                            Email
                                        </Box>
                                    </Box>
                                    <Box
                                        style={{ width: '180px', justifyContant: 'flex-end' }}
                                        display="flex"
                                    >
                                        <Box className={styles.taskLabel} style={{ width: '60%' }}>
                                            Status
                                        </Box>
                                        <Box className={styles.taskLabel} style={{ width: '40%' }}>
                                            Action
                                        </Box>
                                    </Box>
                                </Box>
                                {detail.recipients.map((recipient) => {
                                    let task = detail.tasks.find(
                                        (task) => task.assignee == recipient.sub
                                    );
                                    return (
                                        <Box
                                            display="flex"
                                            flexDirection="row"
                                            className={styles.taskdetailV4}
                                        >
                                            <Box
                                                style={{ width: '70%', overflow: 'hidden' }}
                                                display="flex"
                                                className={styles.statementValue}
                                            >
                                                <Box
                                                    style={{
                                                        width: '50%',
                                                        padding: '10px',
                                                        overflowWrap: 'break-word',
                                                        maxWidth: '50%',
                                                        overflow: 'hidden',
                                                        whiteSpace: 'pre-wrap',
                                                    }}>
                                                    {recipient.displayName}
                                                </Box>
                                                <Box
                                                    style={{
                                                        width: '50%',
                                                        padding: '10px',
                                                        color: '#2057AD',
                                                        overflowWrap: 'break-word',
                                                        maxWidth: '50%',
                                                        overflow: 'hidden',
                                                        whiteSpace: 'pre-wrap',
                                                    }}
                                                >
                                                    {recipient.emailAddress}
                                                </Box>
                                            </Box>
                                            <Box
                                                style={{
                                                    width: '180px',
                                                    justifyContant: 'flex-end',
                                                    float: 'right',
                                                }}
                                                display="flex"
                                                className={styles.statementValue}
                                            >
                                                <Box style={{ width: '60%', padding: '10px' }}>
                                                    {task.deleted
                                                        ? 'Cancelled'
                                                        : task.finished
                                                            ? 'Completed'
                                                            : 'Incomplete'}
                                                </Box>
                                                {!task.finished && !task.deleted && (
                                                    <Box
                                                        style={{
                                                            width: '40%',
                                                            padding: '10px',
                                                            color: '#CC3333',
                                                            cursor: 'pointer',
                                                        }}
                                                        onClick={() =>
                                                            onCancelTask({ ...detail, cancelTaskId: task.id })
                                                        }
                                                    >
                                                        Cancel
                                                    </Box>
                                                )}
                                            </Box>
                                        </Box>
                                    );
                                })}
                            </Box>
                        </Box>
                    )}
                </Fragment>
            )}
        </Fragment>
    );
};

SDFARequest.propTypes = {
    changeView: T.func,
    detail: T.object,
    isNewV4: T.bool,
};

export default memo(SDFARequest);
